import { render, staticRenderFns } from "./MFCLocationAreas.vue?vue&type=template&id=7fc46721&scoped=true"
import script from "./MFCLocationAreas.vue?vue&type=script&lang=js"
export * from "./MFCLocationAreas.vue?vue&type=script&lang=js"
import style0 from "./MFCLocationAreas.vue?vue&type=style&index=0&id=7fc46721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc46721",
  null
  
)

export default component.exports